import axios, { AxiosHeaders, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import EnvLocal from '../../env.local';

const baseURL = EnvLocal.REACT_APP_API_URL;

class ApiService {
  private axiosInstance: AxiosInstance;

  constructor(config?: AxiosRequestConfig) {
    this.axiosInstance = axios.create({
      baseURL,
      ...config,
    });
    this.axiosInstance.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('token');
        if (token) {
          if (config.headers) {
            const headers = new AxiosHeaders(config.headers);
            headers.set('Authorization', `${token}`);
            config.headers = headers;
          } else {
            config.headers = new AxiosHeaders({
              Authorization: `Bearer ${token}`,
            });
          }
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    this.axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        const data = error.response?.data;
    
        if (
          Array.isArray(data) &&
          data.some((e: any) => e.code === 'CONTRACT_INACTIVE')
        ) {
          window.dispatchEvent(new CustomEvent('contract-inactive'));
        }

        if (
          Array.isArray(data) &&
          data.some((e: any) => e.code === 'CONTRACT_INVALID')
        ) {
          window.dispatchEvent(new CustomEvent('contract-invalid'));
        }

        if (
          Array.isArray(data) &&
          data.some((e: any) => e.code === 'NO_ACCESS_COMPANY')
        ) {
          this.get('/v1/auth/refresh-token').then((resp: any) => {
            localStorage.removeItem('token')
            localStorage.setItem('token', resp.data.accessToken)
          })
        }
    
        return Promise.reject(error);
      }
    );

  }

  // Método GET
  async get<T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.axiosInstance.get<T>(url, config);
  }

  // Método POST
  async post<T>(url: string, data: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.axiosInstance.post<T>(url, data, config);
  }

  async postFormData<T>(url: string, data: FormData, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    const formDataHeaders = {
      'Content-Type': 'multipart/form-data',
      ...(config?.headers || {}),
    };

    return this.axiosInstance.post<T>(url, data, {
      ...config,
      headers: formDataHeaders,
    });
  }

  async putFormData<T>(url: string, data: FormData, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    const formDataHeaders = {
      'Content-Type': 'multipart/form-data',
      ...(config?.headers || {}),
    };

    return this.axiosInstance.put<T>(url, data, {
      ...config,
      headers: formDataHeaders,
    });
  }

  // Método PUT
  async put<T>(url: string, data: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.axiosInstance.put<T>(url, data, config);
  }

  // Método DELETE
  async delete<T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.axiosInstance.delete<T>(url, config);
  }

  // Método PATCH
  async patch<T>(url: string, data: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.axiosInstance.patch<T>(url, data, config);
  }
}

export default ApiService;